/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cropaspect1Inputs */

const en_cropaspect1 = /** @type {(inputs: Cropaspect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect ratio`)
};

const de_cropaspect1 = /** @type {(inputs: Cropaspect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenverhältnis`)
};

/**
* | output |
* | --- |
* | "Aspect ratio" |
*
* @param {Cropaspect1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cropaspect1 = /** @type {((inputs?: Cropaspect1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cropaspect1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cropaspect1(inputs)
	return de_cropaspect1(inputs)
});
export { cropaspect1 as "cropAspect" }